import { useState, useEffect } from 'react';

const videoIdCache: Record<string, string> = {};

/**
 * TikTok短縮URLからoEmbed APIを使って動画IDを取得するhook
 * 取得したIDはキャッシュされ、Player v1 APIで再生できるようになる
 */
export function useTikTokVideoId(embedUrl: string): { videoId: string; loading: boolean } {
  const [videoId, setVideoId] = useState<string>(videoIdCache[embedUrl] || '');
  const [loading, setLoading] = useState(!videoIdCache[embedUrl] && !!embedUrl);

  useEffect(() => {
    if (!embedUrl) {
      setLoading(false);
      return;
    }
    if (videoIdCache[embedUrl]) {
      setVideoId(videoIdCache[embedUrl]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    async function fetchVideoId() {
      try {
        const oembedUrl = `https://www.tiktok.com/oembed?url=${encodeURIComponent(embedUrl)}`;
        const res = await fetch(oembedUrl);
        if (!res.ok) throw new Error('oembed fetch failed');
        const data = await res.json();

        let id = '';
        // HTMLのcite属性から /video/VIDEO_ID を抽出
        if (data.html) {
          const match = (data.html as string).match(/\/video\/(\d+)/);
          if (match) id = match[1];
        }
        // embed_product_id フォールバック
        if (!id && data.embed_product_id) {
          id = String(data.embed_product_id);
        }

        if (!cancelled && id) {
          videoIdCache[embedUrl] = id;
          setVideoId(id);
        }
      } catch {
        // ignore
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchVideoId();
    return () => {
      cancelled = true;
    };
  }, [embedUrl]);

  return { videoId, loading };
}
